"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class AdobeClient {
    clientId;
    clientSecret;
    constructor(host, clientId, clientSecret, timeout = 2000) {
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        this.httpClient = axios_1.default.create({
            baseURL: host,
            timeout: timeout,
        });
    }
    token;
    httpClient;
    tokenExpiracy = 0;
    async generateToken() {
        const requestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        };
        const data = new URLSearchParams({
            client_id: this.clientId,
            client_secret: this.clientSecret,
        }).toString();
        const tokenResponse = await this.httpClient.post('/token', data, requestConfig);
        this.token = tokenResponse.data.access_token;
        this.tokenExpiracy =
            Date.now() + Number(tokenResponse.data.expires_in) - 5000;
    }
    async request(method, path, body, query, headers) {
        if (!this.token || Date.now() >= this.tokenExpiracy) {
            await this.generateToken();
        }
        const response = await this.httpClient.request({
            method,
            url: path,
            headers: { ...this.generateHeaders(), ...headers },
            data: body,
            params: query,
        });
        return response;
    }
    generateHeaders() {
        return {
            'x-api-key': this.clientId,
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.token}`,
        };
    }
}
exports.default = AdobeClient;
